import { useEffect } from "react";

interface ShareModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  copiedHint?: string;
}

const CHANNELS = [
  { icon: "ri-wechat-line", label: "微信", color: "text-secondary-600" },
  { icon: "ri-weibo-line", label: "微博", color: "text-accent-600" },
  { icon: "ri-links-line", label: "复制链接", color: "text-primary-600" },
  { icon: "ri-mail-line", label: "邮件", color: "text-foreground-600" },
  { icon: "ri-message-3-line", label: "短信", color: "text-secondary-600" },
  { icon: "ri-more-line", label: "更多", color: "text-foreground-600" },
];

export default function ShareModal({ open, onClose, title, copiedHint }: ShareModalProps) {
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    if (open) {
      window.addEventListener("keydown", onKey);
    }
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center px-4">
      <div
        className="absolute inset-0 bg-primary-950/50 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="relative w-full max-w-sm bg-background-50 rounded-lg p-6 border border-background-200">
        <div className="flex items-start justify-between gap-4 mb-5">
          <div>
            <h4 className="font-heading font-semibold text-base text-foreground-950">分享</h4>
            {title && (
              <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{title}</p>
            )}
          </div>
          <button
            type="button"
            aria-label="关闭分享弹窗"
            onClick={onClose}
            className="flex items-center justify-center w-8 h-8 rounded-md text-foreground-500 hover:bg-background-100 transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-lg" />
          </button>
        </div>

        <div className="grid grid-cols-3 gap-3">
          {CHANNELS.map((channel) => (
            <button
              key={channel.label}
              type="button"
              onClick={onClose}
              className="flex flex-col items-center gap-2 py-3 rounded-lg bg-background-100 hover:bg-background-200 transition-colors cursor-pointer"
            >
              <span className={`flex items-center justify-center w-10 h-10 rounded-full bg-background-50 ${channel.color}`}>
                <i className={`${channel.icon} text-xl`} />
              </span>
              <span className="text-xs text-foreground-600">{channel.label}</span>
            </button>
          ))}
        </div>

        <p className="mt-5 text-xs text-foreground-400 text-center leading-relaxed">
          {copiedHint || "分享渠道为演示展示，不会真实发送内容"}
        </p>
      </div>
    </div>
  );
}